import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    investment_data: null,
    category_list:null,
    member_list:null,
    referral_list:null,
    current_category_id:null,
    mutual_fund_data:null,
    show_add_family_member_button:null,
  },
  mutations: {
    user_data_store (state, data) {
      state.user = data
    },
    user_single_store (state, data) {
      state.user[data.key] = data.value
    },
    investment_data_store (state, data) {
      state.investment_data = data
    },
    category_list_data_store (state, data) {
      state.category_list = data
    },
    member_list_data_store (state, data) {
      state.member_list = data
    },
    referral_list_data_store (state, data) {
      state.referral_list = data
    },
    current_category_id_data_store (state, data) {
      state.current_category_id = data
    },
    mutual_fund_data_store (state, data) {
      state.mutual_fund_data = data
    },
    show_add_family_member_data_store (state, data) {
      state.show_add_family_member_button = data
    },

  },
  actions: {
  	commitData ({ commit }, data) {
    	commit('user_data_store', data) 
	  },
    commitSingleData ({ commit }, singledata) {
      commit('user_single_store', singledata) 
    },
    commitInvestmentData ({ commit }, data) {
      commit('investment_data_store', data) 
    },
    commitCategoryListData ({ commit }, data) {
      commit('category_list_data_store', data) 
    },
    commitMemberListData ({ commit }, data) {
      commit('member_list_data_store', data) 
    },
    commitReferralListData ({ commit }, data) {
      commit('referral_list_data_store', data) 
    },

    commitCurrentCategoryIdData ({ commit }, data) {
      commit('current_category_id_data_store', data) 
    },

    commitCurrentMutualFundData ({ commit }, data) {
      commit('mutual_fund_data_store', data) 
    }, 
    commitShowAddFamilyMemberData ({ commit }, data) {
      commit('show_add_family_member_data_store', data) 
    },
  },

  getters:{
   authProfile:(state) => state.user
  }
});

export default store
